<div id="agentKnowledgeBaseContainer" class="panel-body"></div>
